import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import { PENDING_STAB, EMPTY_STAB } from 'utils/stab';
import * as subscriptionPlanActions from 'actions/subscriptionPlan';

const initialState = {
  collection: undefined
};

export default (state = initialState, action) => {
  switch (action.type) {
    case subscriptionPlanActions.FETCH_SUBSCRIPTION_PLANS_PENDING:
      return { collection: PENDING_STAB };

    case subscriptionPlanActions.FETCH_SUBSCRIPTION_PLANS_FAILURE:
      return { collection: EMPTY_STAB };

    case subscriptionPlanActions.FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      return {
        collection: sortBy(
          filter(action.plans, p => parseFloat(p.price.annual.amount) > 0),
          'order'
        )
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/subscriptionPlan.js